import BlogArticleLayout from '@/components/feature/BlogArticleLayout';

export default function ProdutosBaratosPage() {
  return <BlogArticleLayout slug="produtos-baratos-china-2026" />;
}